import { ResolveFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import {
  ApiService,
  Profile,
  ProfileService,
  StorageService,
} from '@app-utils';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { AppLoaderService } from '../services';

export const profileResolver: ResolveFn<boolean> = (
  actroute,
  state,
): Observable<boolean> => {
  const route = inject(Router);
  const storageSvc = inject(StorageService);
  const apiSvc = inject(ApiService);
  const loaderSvc = inject(AppLoaderService);
  const profileSvc = inject(ProfileService);
  const token = storageSvc.getAuthToken();

  // const setImage = (id: string) => {
  //   return apiSvc.getUserImage(id).pipe(
  //     map((userImage) => {
  //       profileSvc.setProfileImage(
  //         userImage.data ? `data:image/jpeg;base64,${userImage.data}` : '',
  //       );
  //       return null;
  //     }),
  //   );
  // };

  loaderSvc.setProfileLoader(true);
  const obs = (
    token
      ? apiSvc.getUserLoginDetail().pipe(
          map((res) => res.data),
          catchError((e) => {
            profileSvc.logout();
            void route.navigate(['/']);
            return throwError(e);
          }),
        )
      : of(null)
  ) as Observable<null | Profile>;
  return obs.pipe(
    tap((userRes) => {
      if (!userRes && !state.url.includes('/auth')) {
        return void route.navigate(['auth']);
      }
      if (
        state.url.includes('/auth') &&
        userRes &&
        !state.url.includes('/auth/invitation') &&
        !state.url.includes('/auth/invite')
      ) {
        return void route.navigate(['/']);
      }

      if (userRes) {
        profileSvc.setProfile(userRes);
      }
      if (userRes?.organisation?.length) {
        profileSvc.setOrganizationList(userRes?.organisation || []);
        // if (orgRes.length === 1 && !profileSvc.latestOrganization()) {
        //   profileSvc.setOrganization(orgRes[0]);
        //   void route.navigate(['org', orgRes[0].id]);
        // }
      }
      // token && setImage(userRes?.id || '').subscribe();
      loaderSvc.setProfileLoader(false);
    }),
    map((data) => !!data),
  );
};
